import { c as _c } from "react/compiler-runtime";
import GridViewIcon from '@bloomberg/web-icons-react/GridView';
import ListViewIcon from '@bloomberg/web-icons-react/ListView';
import type { FC } from 'react';
export const FindIcon: FC<{
  iconName: string;
}> = t0 => {
  const $ = _c(2);
  const {
    iconName
  } = t0;
  switch (iconName) {
    case "listView":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ListViewIcon />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "gridView":
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <GridViewIcon />;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
  }
};